import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";

function Contact() {
  return (
    <>
      <section className="contact-page">
        <HeroPages name="Contact" />
        <div className="container">
          <div className="contact-div">
            <div className="contact-div__text">
              <h2 style={{ fontFamily: 'Montserrat'}}>Need additional information?</h2>
              <p style={{ fontFamily: 'Montserrat'}}>
              Have questions or need more details about our services? We're here to help! Get in touch with us for a seamless and reliable ride experience.
              </p>
              <a href="/">
                <i className="fa-solid fa-phone"></i>&nbsp; (234) 810-619-2990
              </a>
              <a href="/" style={{ fontFamily: 'Montserrat'}}>
                <i className="fa-solid fa-envelope"></i>&nbsp;
                support@wakaforme.com
              </a>
              <a href="/" style={{ fontFamily: 'Montserrat'}}>
                <i className="fa-solid fa-location-dot"></i>&nbsp; Osogbo,
                Osun State
              </a>
            </div>
            <div className="contact-div__form">
              <form action="sendmail.php" method="POST">
                <label>
                  Full Name <b>*</b>
                </label>
                <input type="text" name="name" placeholder='E.g: "Joe Shmoe"' required></input>

                <label>
                  Email <b>*</b>
                </label>
                <input type="email" name="email" placeholder="youremail@example.com" required></input>

                <label>
                  Tell us about it <b>*</b>
                </label>
                <textarea name="message" placeholder="Write Here.." required></textarea>

                <button type="submit">
                  <i className="" style={{ fontFamily: 'Montserrat'}}></i>&nbsp; Send
                  Message
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2 style={{ fontFamily: 'Montserrat'}}>Book a Ride by getting in touch with us</h2>
              <span>
                <i className="fa-solid fa-phone" style={{color:'#f7931e'}}></i>
                <h4 style={{ fontFamily: 'Montserrat', color:'#f7913e'}}>(234) 810-619-2990</h4>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Contact;
